import { IsOptional, IsString } from "class-validator";


export class StoredItemVm {
    @IsString()
    warehouseId: string;

    @IsString()
    locationId: string;

    @IsString()
    productId: string;

    @IsString()
    productName: string;

    @IsString()
    productSku: string;

    @IsString()
    batch: string;

    @IsString()
    serialNumber: string;

    @IsString()
    quantity: number;

    @IsString()
    containerProductId: string;

    @IsString()
    @IsOptional()
    containerProductName: string;

    @IsString()
    @IsOptional()
    containerProductSku: string;

    @IsString()
    @IsOptional()
    containerSerialNumber: string;
}
